import { render, staticRenderFns } from "./styleSubItem.vue?vue&type=template&id=635d95c0&scoped=true&"
import script from "./styleSubItem.vue?vue&type=script&lang=js&"
export * from "./styleSubItem.vue?vue&type=script&lang=js&"
import style0 from "./styleSubItem.vue?vue&type=style&index=0&id=635d95c0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635d95c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('635d95c0')) {
      api.createRecord('635d95c0', component.options)
    } else {
      api.reload('635d95c0', component.options)
    }
    module.hot.accept("./styleSubItem.vue?vue&type=template&id=635d95c0&scoped=true&", function () {
      api.rerender('635d95c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/styleSubItem.vue"
export default component.exports